export default __webpack_public_path__ + "static/media/bottom1 1.a996f93c.png";